import _BaseUserProfile from 'Models/UserProfile/_BaseUserProfile';

export default class AutoInsuranceName extends _BaseUserProfile {
  component = 'TextField';
  props = {
    title: 'Name of auto insurance company:',
    errorMessage: 'This Field is Required',
    additionalFormInModal: false,
  };
}
